import { schema as schemas } from 'normalizr'
import qs from 'qs'

import { CallApi } from '@signavio/kraken'

import { schema as versionSchema } from './version'

export { collection } from './version'

export const schema = new schemas.Array(versionSchema)

type FetchQueryType = {
  id: string
}

type FetchParamsType = {
  pagesize: number
  offset: number
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  (
    { id }: FetchQueryType,
    _: unknown,
    { pagesize, offset }: FetchParamsType
  ) => {
    const requestParams = qs.stringify(
      { offset, pagesize },
      { addQueryPrefix: false }
    )

    return callApi(
      `${apiBase}/workflows/${id}/versions?${requestParams}`,
      schema
    )
  }
